import React from 'react'
import { ProjectListing } from './ProjectListing'
import { createStackNavigator } from '@react-navigation/stack'
import ProjectForm from './ProjectForm'
import { CustomHeader } from '../../../../ui/atoms/CustomHeader'
import { ProjectDetails } from './ProjectDetails'
import { paths } from '../../../links'
import { ProjectListingDesktop } from '../../../Projects/Desktop/ProjectListing'
import { ProjectDetailDesktop } from '../../../Projects/Desktop/ProjectDetail'
import { screenWidth } from '../../../../utils/helpers/commonUtils'

const RootStack = createStackNavigator()

enum Screens {
  mobile = 'mobile',
  desktop = 'desktop',
}

export default () => {
  const screens = {
    [Screens.mobile]: [
      { name: paths.Console.Projects.List, component: ProjectListing },
      { name: paths.Console.Projects.Details, component: ProjectDetails },
      { name: paths.Console.Projects.Form, component: ProjectForm },
    ],
    [Screens.desktop]: [
      { name: paths.Console.Projects.List, component: ProjectListingDesktop },
      { name: paths.Console.Projects.Details, component: ProjectDetailDesktop },
    ],
  }
  return (
    <RootStack.Navigator
      mode="modal"
      // eslint-disable-next-line i18next/no-literal-string
      headerMode="screen"
      initialRouteName={paths.Console.Projects.List}
      screenOptions={{
        header: () => CustomHeader,
      }}
    >
      {screens[screenWidth < 768 ? 'mobile' : 'desktop'].map(
        (screen: { name: string; component: React.ComponentType<any> }) => (
          <RootStack.Screen name={screen.name} component={screen.component} />
        ),
      )}
    </RootStack.Navigator>
  )
}
